import { KEEP_ALIVE_PATHS } from "@/utils/keepAlive";
import Vue from "vue";
import store from "@/stores";
import VueRouter from "vue-router";
Vue.use(VueRouter);

// Fix NavigationDuplicated error
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {
    if (
      err.name !== "NavigationDuplicated" &&
      !err.message.includes("Avoided redundant navigation")
    ) {
      throw err;
    }
  });
};

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => {
    if (
      err.name !== "NavigationDuplicated" &&
      !err.message.includes("Avoided redundant navigation")
    ) {
      throw err;
    }
  });
};

import terms from "@/pages/terms";
import register from "@/pages/auth/register";
import verify_new_user from "@/pages/auth/verify_new_user";
import open_store from "@/pages/auth/open_store";
import verify_account from "@/pages/auth/verify_account";
import login from "@/pages/auth/login";
import forgot_password from "@/pages/auth/forgot_password";
import verify_otp from "@/pages/auth/verify_otp";
import new_password from "@/pages/auth/new_password";
// expense
import expense from "@/pages/expense/expense";
import expenseCategory from "@/pages/expense/expense-category";
// cash & shift management
import cashManagement from "@/pages/cash-management/index";
import shiftManagement from "@/pages/shift-management/index";
import cashDrawers from "@/pages/cash-drawers";

import historySale from "@/pages/history-sale";
import trashProducts from "@/pages/trash-products";
import PageNotFound from "@/pages/404";

// administrator
import administrator from "@/pages/administrator/index";
import orders from "@/pages/administrator/orders";
import feedback from "@/pages/administrator/feedbacks";
import settings from "@/pages/administrator/settings";
import stores from "@/pages/administrator/stores";
import adminStoreDetail from "@/pages/administrator/store/detail";
import branch from "@/pages/administrator/branch";
import packages from "@/pages/administrator/packages";
import users from "@/pages/administrator/users";
import shopCategories from "@/pages/administrator/store/categories";
import shopCustomers from "@/pages/administrator/store/customers";
import shopProducts from "@/pages/administrator/store/products";
import shopUsers from "@/pages/administrator/store/users";
import shopTicketReport from "@/pages/administrator/store/bill-report";
import menuManagement from "@/pages/administrator/menu";

import exchangeRate from "@/pages/settings/exchangeRate.vue";
import permission from "@/pages/settings/permission";
import importData from "@/pages/settings/import";
import exportData from "@/pages/settings/export";

// app
import Sale from "@/pages/sale";
import sort from "@/pages/sort-product";
import products from "@/pages/products";
import overdue from "@/pages/overdue";
import table from "@/pages/table/index";
import overview from "@/pages/overview";
import printers from "@/pages/printers";
import zones from "@/pages/zones";

// manage
import category from "@/pages/manage/categories";
import buffetPlans from "@/pages/manage/buffet-plans";
import productUnit from "@/pages/manage/unit";
import addProduct from "@/pages/manage/add-product";
import editProduct from "@/pages/manage/edit-product";
import productDetail from "@/pages/product-detail";
import managePurchase from "@/pages/manage/purchase";
import manageBarcode from "@/pages/manage/barcode";
import manageSupplier from "@/pages/manage/suppliers";
import manageIngredients from "@/pages/manage/ingredients";
import manageIngredientForm from "@/pages/manage/ingredient-form";
import ingredientRestock from "@/pages/manage/ingredient-restock";
import manageBranch from "@/pages/manage/branches";
import manageCustomer from "@/pages/manage/customers";
import manageUser from "@/pages/manage/users";
import manageStock from "@/pages/manage/stock";
import manageProductOptions from "@/pages/manage/product-options";
import managePriceChannels from "@/pages/manage/price-channels.vue";
import manageStockAdjustment from "@/pages/manage/stockAdjustment";
import reportStockAdjustment from "@/pages/reports/stockAdjustment";
import managePromotions from "@/pages/manage/promotions.vue";
import managePromotionForm from "@/pages/manage/promotion-form.vue";
import manageTopping from "@/pages/manage/topping.vue";
import manageToppingForm from "@/pages/manage/topping-form.vue";

// report
import billReport from "@/pages/reports/bill-report";
import reportUsers from "@/pages/reports/report-users";
import reportCategory from "@/pages/reports/category";
import reportUnit from "@/pages/reports/unit";
import reportSupplier from "@/pages/reports/suppliers";
import reportBranch from "@/pages/reports/branches";
import reportCustomers from "@/pages/reports/customers";
import reportUser from "@/pages/reports/users";
import reportPurchase from "@/pages/reports/purchase";
import stockAlertReport from "@/pages/reports/stock-alert-report";
import stockReport from "@/pages/reports/stock-report.vue";
import productReport from "@/pages/reports/product-report.vue";
import wasteManagement from "@/pages/manage/waste-management.vue";
import wasteRequests from "@/pages/reports/waste-requests.vue";
import discountVoidRefundReport from "@/pages/reports/discount-void-refund-report.vue";
import privacy from "@/pages/privacy";

// landing page
import index from "@/pages/index";
import contact_us from "@/pages/contact_us";
import faq from "@/pages/faq";
import partners from "@/pages/landing/partners";
import tutorials from "@/pages/landing/tutorials";

// scan
import scan from "@/pages/scan/index";
import cart from "@/pages/scan/cart";
import receipt from "@/pages/scan/receipt";
import kitchen from "@/pages/kitchen";
import customer_screen from "@/pages/customer_screen";
import documents from "@/pages/documents";
import variationsDemo from "@/pages/variations-demo";

// online dashboard
import layouts from "@/pages/dashboard/layouts";
import dashboard from "@/pages/dashboard";
import dashboardBanners from "@/pages/dashboard/banners";
import dashboardProducts from "@/pages/dashboard/products";
import dashboardCategories from "@/pages/dashboard/categories";
import dashboardOrders from "@/pages/dashboard/orders";
import dashboardShipping from "@/pages/dashboard/shipping";
import dashboardPayment from "@/pages/dashboard/payments";
import dashboardUsers from "@/pages/dashboard/users";
import dashboardSettings from "@/pages/dashboard/settings";

// marketplace (merchant POS)
import marketplaceOrders from "@/pages/marketplace/orders";
import marketplaceOrderDetail from "@/pages/marketplace/order-detail";

// price checker
import priceChecker from "@/pages/price-checker";

const router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: index,
      meta: {
        layout: "blank",
        requiresAuth: false,
        status: [],
      },
    },
    {
      path: "/contact_us",
      name: "contact_us",
      component: contact_us,
      meta: {
        layout: "blank",
        requiresAuth: false,
        status: [],
      },
    },
    {
      path: "/faq",
      name: "faq",
      component: faq,
      meta: {
        layout: "blank",
        requiresAuth: false,
        status: [],
      },
    },
    // {
    //   path: "/grocery",
    //   name: "GROCERY",
    //   component: grocery,
    //   meta: {
    //     layout: "basic",
    //     requiresAuth: false,
    //     status: [],
    //   },
    // },
    {
      path: "/partners",
      name: "partners",
      component: partners,
      meta: {
        layout: "basic",
        requiresAuth: false,
        status: [],
      },
    },
    {
      path: "/tutorials",
      name: "tutorials",
      component: tutorials,
      meta: {
        layout: "basic",
        requiresAuth: false,
        status: [],
      },
    },
    {
      path: "/register",
      name: "register",
      component: register,
      meta: {
        layout: "blank",
        requiresAuth: false,
        status: [],
      },
    },
    {
      path: "/privacy",
      name: "privacy",
      component: privacy,
      meta: {
        layout: "blank",
        requiresAuth: false,
        status: [],
      },
    },
    {
      path: "/sale",
      name: "sale",
      component: Sale,
      meta: {
        requiresAuth: true,
        layout: "default",
        store: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/terms",
      name: "terms",
      component: terms,
      meta: {
        layout: "blank",
        requiresAuth: false,
        status: [],
      },
    },
    {
      path: "/verify-new-user",
      name: "verify_new_user",
      component: verify_new_user,
      meta: {
        layout: "blank",
        requiresAuth: false,
        status: [],
      },
    },
    {
      path: "/open-store",
      name: "open_store",
      component: open_store,
      meta: {
        layout: "blank",
        requiresAuth: true,
        status: [2],
      },
    },
    // removed open-branch route
    {
      path: "/verify-account",
      name: "verify_account",
      component: verify_account,
      meta: {
        layout: "blank",
        requiresAuth: false,
        status: [2],
      },
    },
    {
      path: "/login",
      name: "login",
      component: login,
      meta: {
        layout: "blank",
        requiresAuth: false,
        status: [],
      },
    },
    {
      path: "/forgot-password",
      name: "forgot_password",
      component: forgot_password,
      meta: {
        layout: "blank",
        requiresAuth: false,
        status: [],
      },
    },
    {
      path: "/verify-otp",
      name: "verify_otp",
      component: verify_otp,
      meta: {
        layout: "blank",
        requiresAuth: false,
        status: [],
      },
    },
    {
      path: "/new-password",
      name: "new_password",
      component: new_password,
      meta: {
        layout: "blank",
        requiresAuth: false,
        status: [],
      },
    },
    {
      path: "/sort-product",
      name: "sort_product",
      component: sort,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },

    {
      path: "/expense",
      name: "expense",
      component: expense,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/expense-category",
      name: "expense_category",
      component: expenseCategory,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/cash-management",
      name: "cash_management",
      component: cashManagement,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/shift-management",
      name: "shift_management",
      component: shiftManagement,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/cash-drawers",
      name: "cash-drawers",
      component: cashDrawers,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },

    // manage
    {
      path: "/manage-category",
      name: "manage_category",
      component: category,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/manage/buffet-plans",
      name: "manage_buffet_plans",
      component: buffetPlans,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/manage-product-unit",
      name: "manage_product_unit",
      component: productUnit,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/manage-add-product",
      name: "manage_add_product",
      component: addProduct,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/product-detail/:id",
      name: "product_detail",
      component: productDetail,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/manage-customers",
      name: "manage_customers",
      component: manageCustomer,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/manage-barcode",
      name: "manage_barcode",
      component: manageBarcode,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/price-checker",
      name: "price_checker",
      component: priceChecker,
      meta: {
        layout: "blank",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },

    {
      path: "/manage-branches",
      name: "manage_branches",
      component: manageBranch,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/manage-suppliers",
      name: "manage_suppliers",
      component: manageSupplier,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/manage-ingredients",
      name: "manage_ingredients",
      component: manageIngredients,
      meta: { layout: "product", requiresAuth: true, status: [2, 3, 4, 5] },
    },
    {
      path: "/manage-ingredients/new",
      name: "manage_ingredients_create",
      component: manageIngredientForm,
      meta: {
        layout: "product", requiresAuth: true, status: [2, 3, 4, 5],
        permissionCode: "manage_product_recipe", permissionRedirect: "/manage-ingredients",
      },
    },
    {
      path: "/manage-ingredients/:id",
      name: "manage_ingredients_edit",
      component: manageIngredientForm,
      meta: {
        layout: "product", requiresAuth: true, status: [2, 3, 4, 5],
        permissionCode: "manage_product_recipe", permissionRedirect: "/manage-ingredients",
      },
    },
    {
      path: "/ingredient-restock",
      name: "ingredient_restock",
      component: ingredientRestock,
      meta: {
        layout: "product", requiresAuth: true, status: [2, 3, 4, 5],
        permissionCode: "manage_product_recipe", permissionRedirect: "/manage-ingredients",
      },
    },

    {
      path: "/manage-product-options",
      name: "manage_product_options",
      component: manageProductOptions,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/manage-price-channels",
      name: "price_channels",
      component: managePriceChannels,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/manage-stock-adjustment",
      name: "manage_stock_adjustment",
      component: manageStockAdjustment,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/report-stock-adjustment",
      name: "report_stock_adjustment",
      component: reportStockAdjustment,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/manage-promotions",
      name: "manage_promotions",
      component: managePromotions,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/manage-promotions/new",
      name: "manage_promotions_create",
      component: managePromotionForm,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/manage-promotions/:id",
      name: "manage_promotions_edit",
      component: managePromotionForm,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/manage-topping",
      name: "manage_topping",
      component: manageTopping,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/manage-topping/new",
      name: "manage_topping_create",
      component: manageToppingForm,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/manage-topping/:id",
      name: "manage_topping_edit",
      component: manageToppingForm,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },

    {
      path: "/manage-purchase",
      name: "manage_purchase",
      component: managePurchase,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/manage-waste",
      name: "waste_management",
      component: wasteManagement,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/waste-request",
      name: "waste_requests",
      component: wasteRequests,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },

    {
      path: "/manage-edit-product/:id",
      name: "edit_product",
      component: editProduct,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/variations-demo",
      name: "variations_demo",
      component: variationsDemo,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/overdue",
      name: "overdue",
      component: overdue,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },

    {
      path: "/products",
      name: "products",
      component: products,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/trash-products",
      name: "trash_products",
      component: trashProducts,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/history-sale",
      name: "history_sale",
      component: historySale,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },

    {
      path: "/report-purchase",
      name: "report_purchase",
      component: reportPurchase,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/report-product",
      redirect: "/report-bill?tab=product",
    },
    {
      path: "/report-category",
      name: "report_category",
      component: reportCategory,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/report-unit",
      name: "report_unit",
      component: reportUnit,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/report-suppliers",
      name: "report_suppliers",
      component: reportSupplier,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/report-branches",
      name: "report_branches",
      component: reportBranch,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },

    {
      path: "/report-customers",
      name: "report_customers",
      component: reportCustomers,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/report-users",
      name: "report_users",
      component: reportUser,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/notifications",
      name: "notifications",
      component: () => import("@/pages/notifications.vue"),
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/report-bill",
      name: "report_bill",
      component: billReport,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/report-discount-void-refund",
      name: "report_discount_void_refund",
      component: discountVoidRefundReport,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/report-stock",
      name: "report_stock",
      component: stockReport,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
        permissionExempt: true,
        permissionCode: "report",
      },
    },
    {
      path: "/report-stock-alert",
      redirect: "/report-stock?tab=alert",
    },

    {
      path: "/user-report/:id",
      name: "user_report",
      component: reportUsers,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },

    {
      path: "/settings-exchange-rate",
      name: "exchangeRate",
      component: exchangeRate,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/settings-permission",
      name: "permission",
      component: permission,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/manage-users",
      name: "manage_users",
      component: manageUser,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/manage-stock",
      name: "stock",
      component: manageStock,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/table",
      name: "table",
      component: table,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/mobile/table",
      name: "mobile_table",
      component: () => import("@/pages/table/mobile.vue"),
      meta: {
        layout: "blank",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/overview",
      name: "overview",
      component: overview,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/marketplace-orders",
      name: "marketplace_orders",
      component: marketplaceOrders,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/marketplace-orders/:id",
      name: "marketplace_order_detail",
      component: marketplaceOrderDetail,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/settings-import",
      name: "settings_import",
      component: importData,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/settings-export",
      name: "settings_export",
      component: exportData,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/settings-general",
      name: "settings_general",
      component: () => import("@/pages/setting-responsive.vue"),
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/printers",
      name: "printers",
      component: printers,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/zones",
      name: "zones",
      component: zones,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },

    // for admin
    {
      path: "/administrator",
      redirect: { name: "administrator" },
    },
    {
      path: "/administrator/index",
      name: "administrator",
      component: administrator,
      meta: {
        layout: "admin",
        requiresAuth: true,
        status: [1],
      },
    },
    {
      path: "/administrator/orders",
      name: "orders",
      component: orders,
      meta: {
        layout: "admin",
        requiresAuth: true,
        status: [1],
      },
    },

    {
      path: "/administrator/stores",
      name: "stores",
      component: stores,
      meta: {
        layout: "admin",
        requiresAuth: true,
        status: [1],
      },
    },
    {
      path: "/administrator/store/:store_id",
      name: "admin_store_detail",
      component: adminStoreDetail,
      meta: {
        layout: "admin",
        requiresAuth: true,
        status: [1],
      },
    },
    {
      path: "/administrator/store-ticket/:store_id",
      name: "store_ticket",
      component: shopTicketReport,
      meta: {
        layout: "admin",
        requiresAuth: true,
        status: [1],
      },
    },
    {
      path: "/administrator/branch:store_id",
      name: "store_id",
      component: branch,
      meta: {
        layout: "admin",
        requiresAuth: true,
        status: [1],
      },
    },
    {
      path: "/administrator/packages",
      name: "packages",
      component: packages,
      meta: {
        layout: "admin",
        requiresAuth: true,
        status: [1],
      },
    },
    {
      path: "/administrator/users",
      name: "users",
      component: users,
      meta: {
        layout: "admin",
        requiresAuth: true,
        status: [1],
      },
    },
    {
      path: "/administrator/user-trash",
      name: "user_trash",
      component: () => import("@/pages/administrator/user-trash.vue"),
      meta: {
        layout: "admin",
        requiresAuth: true,
        status: [1],
      },
    },
    {
      path: "/administrator/invoice",
      redirect: "/administrator/documents/invoices",
    },
    {
      path: "/administrator/menu",
      name: "menu_management",
      component: menuManagement,
      meta: {
        layout: "admin",
        requiresAuth: true,
        status: [1],
      },
    },
    {
      path: "/administrator/hardware",
      name: "hardware_catalog",
      component: () => import("@/pages/administrator/hardware.vue"),
      meta: {
        layout: "admin",
        requiresAuth: true,
        status: [1],
      },
    },
    {
      path: "/administrator/documents/quotations",
      name: "solution_document_quotations",
      component: () => import("@/pages/administrator/solution-documents.vue"),
      props: { documentType: "quotation" },
      meta: {
        layout: "admin",
        requiresAuth: true,
        status: [1],
      },
    },
    {
      path: "/administrator/documents/invoices",
      name: "solution_document_invoices",
      component: () => import("@/pages/administrator/solution-documents.vue"),
      props: { documentType: "invoice" },
      meta: {
        layout: "admin",
        requiresAuth: true,
        status: [1],
      },
    },
    {
      path: "/administrator/documents/receipts",
      name: "solution_document_receipts",
      component: () => import("@/pages/administrator/solution-documents.vue"),
      props: { documentType: "receipt" },
      meta: {
        layout: "admin",
        requiresAuth: true,
        status: [1],
      },
    },
    {
      path: "/administrator/hardware-quotations",
      redirect: { name: "solution_document_quotations" },
    },
    {
      path: "/administrator/announcements",
      name: "announcements",
      component: () => import("@/pages/administrator/announcements.vue"),
      meta: {
        layout: "admin",
        requiresAuth: true,
        status: [1],
      },
    },
    {
      path: "/administrator/feedback",
      name: "administrator_feedback",
      component: feedback,
      meta: {
        layout: "admin",
        requiresAuth: true,
        status: [1],
      },
    },
    {
      path: "/administrator/setting",
      name: "administrator_setting",
      component: settings,
      meta: {
        layout: "admin",
        requiresAuth: true,
        status: [1],
      },
    },
    {
      path: "/store-categories/:store_id",
      name: "store_categories",
      component: shopCategories,
      meta: {
        layout: "admin",
        requiresAuth: true,
        status: [1],
      },
    },
    {
      path: "/store-customers/:store_id",
      name: "store_customers",
      component: shopCustomers,
      meta: {
        layout: "admin",
        requiresAuth: true,
        status: [1],
      },
    },
    {
      path: "/store-products/:store_id",
      name: "store_products",
      component: shopProducts,
      meta: {
        layout: "admin",
        requiresAuth: true,
        status: [1],
      },
    },
    {
      path: "/store-users/:store_id",
      name: "store_user",
      component: shopUsers,
      meta: {
        layout: "admin",
        requiresAuth: true,
        status: [1],
      },
    },
    {
      path: "*",
      name: "404",
      component: PageNotFound,
      meta: {
        layout: "blank",
      },
    },
    // scan
    {
      path: "/scan/:store_id/:branch_id/:table_id",
      name: "scan",
      component: scan,
      meta: {
        layout: "blank",
        requiresAuth: false,
        status: [],
      },
    },
    {
      path: "/cart",
      name: "cart",
      component: cart,
      meta: {
        layout: "blank",
        requiresAuth: false,
        status: [],
      },
    },
    {
      path: "/receipt",
      name: "receipt",
      component: receipt,
      meta: {
        layout: "blank",
        requiresAuth: false,
        status: [],
      },
    },
    {
      path: "/kitchen",
      name: "kitchen",
      component: kitchen,
      meta: {
        requiresAuth: true,
        layout: "blank",
        store: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/customer-screen",
      name: "customer_screen",
      component: customer_screen,
      meta: {
        requiresAuth: true,
        layout: "blank",
        store: true,
        status: [2, 3, 4, 5],
      },
    },
    {
      path: "/documents",
      name: "documents",
      component: documents,
      meta: {
        layout: "product",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
    },
    // online dashboard
    // group dashboard,products,categories,orders,users,settings
    {
      path: "/dashboard",
      name: "dashboard",
      component: layouts,
      meta: {
        layout: "online",
        requiresAuth: true,
        status: [2, 3, 4, 5],
      },
      children: [
        {
          path: "/dashboard/index",
          name: "dashboard_index",
          component: dashboard,
          meta: {
            layout: "online",
            requiresAuth: true,
            status: [2, 3, 4, 5],
          },
        },
        {
          path: "/dashboard/banners",
          name: "banners",
          component: dashboardBanners,
          meta: {
            layout: "online",
            requiresAuth: true,
            status: [2, 3, 4, 5],
          },
        },
        {
          path: "/dashboard/products",
          name: "dashboard_products",
          component: dashboardProducts,
          meta: {
            layout: "online",
            requiresAuth: true,
            status: [2, 3, 4, 5],
          },
        },
        {
          path: "/dashboard/categories",
          name: "dashboard_categories",
          component: dashboardCategories,
          meta: {
            layout: "online",
            requiresAuth: true,
            status: [2, 3, 4, 5],
          },
        },
        {
          path: "/dashboard/orders",
          name: "dashboard_orders",
          component: dashboardOrders,
          meta: {
            layout: "online",
            requiresAuth: true,
            status: [2, 3, 4, 5],
          },
        },
        {
          path: "/dashboard/shipping",
          name: "dashboard_shipping",
          component: dashboardShipping,
          meta: {
            layout: "online",
            requiresAuth: true,
            status: [2, 3, 4, 5],
          },
        },
        {
          path: "/dashboard/payments",
          name: "dashboard_payments",
          component: dashboardPayment,
          meta: {
            layout: "online",
            requiresAuth: true,
            status: [2, 3, 4, 5],
          },
        },
        {
          path: "/dashboard/users",
          name: "dashboard_users",
          component: dashboardUsers,
          meta: {
            layout: "online",
            requiresAuth: true,
            status: [2, 3, 4, 5],
          },
        },
        {
          path: "/dashboard/settings",
          name: "settings",
          component: dashboardSettings,
          meta: {
            layout: "online",
            requiresAuth: true,
            status: [2, 3, 4, 5],
          },
        },
      ],
    },
  ],
});
router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters["auth/isLoggedIn"];
  const user = store.getters["auth/user"];
  const { requiresAuth, status } = to.meta;
  const isAdmin = user && user.role === 1;
  const includes = Array.isArray(status) && status.includes(user.role);

  if (requiresAuth && !isLoggedIn) {
    return next("/login");
  }

  if (
    requiresAuth &&
    isLoggedIn &&
    !isAdmin &&
    !includes &&
    user.stores &&
    user.branch_id
  ) {
    return next("/sale");
  }

  if (
    !requiresAuth &&
    isLoggedIn &&
    !isAdmin &&
    user.stores &&
    user.branch_id
  ) {
    return next("/sale");
  }

  if (requiresAuth && isLoggedIn && isAdmin && !includes) {
    return next({ name: "administrator" });
  }

  if (!requiresAuth && isLoggedIn && isAdmin) {
    return next({ name: "administrator" });
  }

  next();
});
// <keep-alive :include> matches the component `name`; many pages have none, so assign one here.
export const keepAliveNames = [];
router.options.routes.forEach((r) => {
  if (
    KEEP_ALIVE_PATHS.includes(r.path) &&
    r.component &&
    typeof r.component === "object"
  ) {
    r.component.name = r.component.name || `KeepAlive_${r.name || r.path}`;
    keepAliveNames.push(r.component.name);
  }
});

export default router;
